import Text from '@cartwhl/ui/base/TextNew';

export interface DashboardPlaceholderSectionProps {
  title: string;
  description: string;
}

export default function DashboardPlaceholderSection({
  title,
  description,
}: DashboardPlaceholderSectionProps) {
  return (
    <section className="mx-auto flex min-h-[240px] max-w-[1020px] flex-col gap-3">
      <Text
        as="h1"
        token="display/20/medium"
        leading="headline"
        className="text-primary text-pretty"
      >
        {title}
      </Text>
      <Text token="14" className="text-secondary text-pretty">
        {description}
      </Text>
    </section>
  );
}
